import { render, staticRenderFns } from "./Prenota.vue?vue&type=template&id=04d5c004&"
import script from "./Prenota.vue?vue&type=script&lang=js&"
export * from "./Prenota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports